import { motion } from 'framer-motion';
import styled from 'styled-components';

const StyledButton = styled(motion.button)`
  padding: 10px 20px;
  font-size: 1.4rem;
  outline: none;
  border: none;
  border-radius: 5px;
  color: ${(props) => props.theme.text};
  cursor: pointer;
  background: none;
  display: inline-flex;
`;

export default StyledButton;
